/**
 * Authorisation map which has method names and thier role permissions
 */
const AUTHORISATION_MAP = {
  getTechnicianGroups: 'technicianGroup.view',
  getClientUser: 'users.view',
  getMSPContacts: 'mspInformation.view',
  getSLAConfiguration: 'slaMetric.view',
  getAllPriority: 'impactUrgencyPriority.view',
  isPriorityMatrixEnabled: 'impactUrgencyPriority.view',
  getAllUrgency: 'impactUrgencyPriority.view',
  getAllImpact: 'impactUrgencyPriority.view',
  getPriorityMatrix: 'impactUrgencyPriority.view',
  getAllResolutionCode: 'resolutionCode.view',
  getAllStatus: 'status.view',
  getStatusConfiguration: 'status.view',
  getAllCategory: 'categorySubcategory.view',
  getInvoiceSettings: 'invoiceSettings.view'
};

export { AUTHORISATION_MAP };
